export default "__VITE_ASSET__Cdqw4KMw__"